module.exports = __webpack_public_path__ + "21dce34947de216c0df1094b319ec643.svg";